<div class="fm-authentication">
  <div class="container-fluid fm-container-full">
    <div class="row h-100">

      <!-- Cover Image -->
      <div class="col-lg-6 p-0 position-relative d-none d-lg-block">
        <div class="fm-cover-image">
          <img src="images/signin/fm-signin-bg.png" alt="Forgot Password" class="img-fluid" />
        </div>
      </div>

      <!-- Card -->
      <div class="col-lg-6">
        <div class="row h-100 justify-content-center align-items-center">
          <div class="col-sm-11">
            <div class="fm-auth-card">

              <!-- Success State -->
              @if (isSuccess()) {
                <div class="text-center fm-auth-chead">
                  <div class="fm-fp-icon success">
                    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                      <polyline points="22,6 12,13 2,6"></polyline>
                    </svg>
                  </div>
                  <h3 class="fm-head-28 fm-head-sty2 fw-title fw-bold">Check Your Inbox!</h3>
                  <p class="text-muted">A password reset link has been sent to your email address. Please check your inbox and follow the instructions.</p>
                  <div class="fm-countdown-badge">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>
                    Redirecting to login in {{ countdown() }}s
                  </div>
                </div>
              } @else {

                <!-- Form State -->
                <div class="fm-auth-chead">
                  <div class="fm-logo mb-4">
                    <a routerLink="/"><img src="images/logo.svg" width="213" alt="Forever Memories" /></a>
                  </div>
                  <div class="d-flex align-items-center gap-3 mb-2">
                    <div class="fm-fp-icon mb-0">
                      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                        <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                      </svg>
                    </div>
                    <h3 class="fm-head-28 fm-head-sty2 fw-title fw-bold mb-0">Forgot Password?</h3>
                  </div>
                  <p class="text-muted">No worries! Enter your registered email and we'll send you a link to reset your password.</p>
                </div>

                <div class="fm-signin-form mt-4">
                  <form [formGroup]="forgotForm" (ngSubmit)="onSubmit()" novalidate>
                    <fieldset class="row g-3 g-sm-4">
                      <div class="col-12">
                        <div class="form-group">
                          <label class="fm-label">Email Address <span class="fm-required">*</span></label>
                          <input
                            type="email"
                            placeholder="Enter your registered email"
                            class="form-control"
                            [class.is-invalid]="f['email'].invalid && f['email'].touched"
                            formControlName="email"
                            autocomplete="email" />
                          @if (f['email'].errors?.['required'] && f['email'].touched) {
                            <div class="invalid-feedback">Email is required.</div>
                          }
                          @if (f['email'].errors?.['email'] && f['email'].touched) {
                            <div class="invalid-feedback">Please enter a valid email address.</div>
                          }
                        </div>
                      </div>
                      <div class="col-12">
                        <button class="fm-common-btn w-100 mt-2 mt-lg-3" type="submit" [disabled]="isLoading()">
                          @if (isLoading()) {
                            <span class="spinner-border spinner-border-sm me-2" role="status"></span>Sending...
                          } @else {
                            Send Reset Link
                          }
                        </button>
                      </div>
                      <div class="col-12 text-center">
                        <p class="text-muted small">
                          Remember your password?
                          <a routerLink="/login" class="fm-basic-link">Back to Sign In</a>
                        </p>
                      </div>
                    </fieldset>
                  </form>
                </div>

              }

            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
